import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { trackSelfDescribingEvent } from '@snowplow/browser-tracker'

export type AuthState = 'started' | 'succeeded' | 'failed'

export type AuthProvider = 'google' | 'fb' | 'apple' | 'email'

export function logOperational(subject: string, action: string) {
  trackSelfDescribingEvent({
    context: [],
    event: comluxgroup.createClientEvent_1_0_0({
      action,
      subject,
      category: 'logging',
      type: 'operational',
    }),
  })
}

export function logRegistration(provider: AuthProvider, state: AuthState, extra?: string) {
  trackSelfDescribingEvent({
    context: [],
    event: comluxgroup.createClientEvent_1_0_0({
      action: [extra, `${state}`].filter(i => !!i).join('_'),
      subject: `${provider}_registration`,
      category: 'logging',
      type: 'operational',
    }),
  })
}

export function logAuth(provider: AuthProvider, state: AuthState, extra?: string) {
  trackSelfDescribingEvent({
    context: [],
    event: comluxgroup.createClientEvent_1_0_0({
      action: [extra, `${state}`].filter(i => !!i).join('_'),
      subject: `${provider}_auth`,
      category: 'logging',
      type: 'operational',
    }),
  })
}
